import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import LightboxCustom from "../Lightbox"

const ImgWithLightBox = props => {
  const {
    onClick,
    multiple,
    btnClassName,
    src = "",
    alt = "",
    images,
    manual,
    preview = "all",
    selected = 0,
    onChange,
    ...otherProps
  } = props
  const [isOpen, setIsOpen] = useState(false)
  const [currentImg, setCurrentImg] = useState(selected)

  useEffect(() => {
    if (manual) setCurrentImg(+selected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  useEffect(() => {
    if (manual && onChange) onChange(currentImg)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentImg])

  const toggle = () => setIsOpen(prev => !prev)

  const handleClick = e => {
    e.preventDefault()
    e.stopPropagation()
    if (onClick && typeof onClick === "function") onClick(e)
    toggle()
  }

  const handleSelectImg = imgIdx => e => {
    e.preventDefault()
    e.stopPropagation()
    if (onClick && typeof onClick === "function") onClick(e)
    setCurrentImg(imgIdx)
    toggle()
  }

  const handleChange = newIdx => {
    setCurrentImg(newIdx)
  }

  const renderImgs = () => {
    if (!multiple)
      return (
        <a
          onClick={handleClick}
          href="#img-preview"
          className={btnClassName}
          role="button"
        >
          <img {...otherProps} alt={alt} src={src} />
        </a>
      )
    if (!Array.isArray(images)) return null
    if (preview === "selected" && images[selected]) {
      return (
        <a
          onClick={handleClick}
          href="#img-preview"
          className={btnClassName}
          role="button"
        >
          <img
            {...otherProps}
            alt={images[selected].alt}
            src={images[selected].src}
          />
        </a>
      )
    }
    return images.map(({ src: itemSrc, alt: itemAlt, ...item }, i) => (
      <a
        onClick={handleSelectImg(i)}
        href="#img-preview"
        className={btnClassName}
        role="button"
        key={`ImgWithLightBox-${i}-thumb`}
      >
        <img {...item} alt={itemAlt} src={item.thumb || itemSrc} />
      </a>
    ))
  }

  return (
    <Fragment>
      {renderImgs()}
      <LightboxCustom
        toggleLig={toggle}
        isOpen={isOpen}
        images={multiple ? images : [props, props]}
        manual={multiple}
        onChange={handleChange}
        activeIndex={currentImg}
      />
    </Fragment>
  )
}

ImgWithLightBox.propTypes = {
  style: PropTypes.shape,
  className: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string,
  title: PropTypes.string,
  multiple: PropTypes.bool,
  preview: PropTypes.oneOf(["selected", "all"]),
  images: PropTypes.arrayOf(
    PropTypes.shape({
      style: PropTypes.shape,
      className: PropTypes.string,
      alt: PropTypes.string,
      src: PropTypes.string,
    })
  ),
}

export default ImgWithLightBox
